module.exports = __webpack_public_path__ + "media/images/dashboard-resources-c554a2b9.png";